var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispatchedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.218,
    height: 44.291,
    viewBox: "0 0 33.218 44.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19158",
    "data-name": "Group 19158",
    transform: "translate(-4543.9 5206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker",
    "data-name": "Icon awesome-map-marker",
    d: "M14.9,43.4C2.333,25.176,0,23.306,0,16.609a16.609,16.609,0,0,1,33.218,0c0,6.7-2.333,8.567-14.9,26.788a2.077,2.077,0,0,1-3.414,0Z",
    transform: "translate(4543.9 -5206)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-home",
    "data-name": "Icon ionic-md-home",
    d: "M9.6,19.439V14.46h3.735v4.98h3.8V11.97h2.428L11.467,4.5,3.375,11.97H5.8v7.47Z",
    transform: "translate(4549.042 -5203.294)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchedPin);
export default __webpack_public_path__ + "static/media/dispatched-pin.ff252edc671fa243e7fda13949ea456f.svg";
export { ForwardRef as ReactComponent };